import { registerComponent } from '../app'
import { tns } from 'tiny-slider/src/tiny-slider'
import { SELECT_SS_CATEGORY } from '../events'

const SSCarousel = (scope, el) => {
	const els = {
		container: el.querySelector('[data-items]'),
		items: el.querySelectorAll('[data-item]'),
		backgrounds: el.querySelectorAll('[data-background]')
	}

	const itemHash = {}

	for (let i = 0; i < els.items.length; i++) {
		itemHash[els.items[i].getAttribute('data-category')] = {
			index: i,
			color: els.items[i].getAttribute('data-color')
		}
	}

	const slider = tns({
		container: els.container,
		items: 1,
		slideBy: 'page',
		mouseDrag: true,
		autoplayButtonOutput: false,
		preventScrollOnTouch: 'auto'
	})

	slider.events.on('indexChanged', info => {
		scope.emit(SELECT_SS_CATEGORY, info.slideItems[info.index].getAttribute('data-category'))
	})

	scope.on(SELECT_SS_CATEGORY, category => {
		if (els.backgrounds.length) {
			for (let i = 0; i < els.backgrounds.length; i++) {
				els.backgrounds[i].style.backgroundColor = itemHash[category].color
			}
		}
		if (itemHash[category].index != slider.getInfo().navCurrentIndex) {
			slider.goTo(itemHash[category].index)
		}
	})
}

registerComponent('ss-carousel', SSCarousel)
